import React from 'react';

import {withRouter, type WithRouterProps} from 'react-router';

import {
  applyFilter,
  DashboardFilterbar,
} from 'app/general/dashboards/DashboardFilterbar';
import {SearchInputField} from 'app/general/widgets/SearchInputField';

import type {TagsDashboardLocationParamsType} from 'app/tags/types';
type Props = {
  viewingAll: boolean;
  resetFilters: () => void;
} & WithRouterProps<TagsDashboardLocationParamsType>;

export const TagsFilterbar = withRouter(
  ({router, location, resetFilters, viewingAll}: Props) => {
    const onSearch = (search) => {
      applyFilter(router, location, {
        search: search,
      });
    };

    return (
      <DashboardFilterbar resetFilters={resetFilters} viewingAll={viewingAll}>
        <div className="col">
          <SearchInputField
            value={location.query.search != null ? location.query.search : ''}
            onChange={onSearch}
          />
        </div>
      </DashboardFilterbar>
    );
  }
);
